import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  EmailAddress: any;
  JSON: any;
  JWT: any;
  Latitude: any;
  Longitude: any;
  PositiveInt: any;
  PostalCode: any;
};

export type AccessTokens = {
  __typename?: 'AccessTokens';
  accessToken?: Maybe<Scalars['JWT']>;
  refreshToken?: Maybe<Scalars['JWT']>;
};

export type Account = {
  __typename?: 'Account';
  createdAt: Scalars['DateTime'];
  email: Scalars['EmailAddress'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastActive?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type AddCheckoutDiscountInput = {
  discountName: Scalars['String'];
  producerId: Scalars['ID'];
};

export type AddToCartInput = {
  cartId: Scalars['ID'];
  category: Scalars['String'];
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  quantity?: InputMaybe<Scalars['Int']>;
  storeId: Scalars['ID'];
  subCategory: Scalars['String'];
  type: ProductVariantType;
  unit: Scalars['String'];
  unitQuantity?: InputMaybe<Scalars['Int']>;
  variantName?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  Billing = 'BILLING',
  Shipping = 'SHIPPING'
}

export type Cart = {
  __typename?: 'Cart';
  createdAt: Scalars['DateTime'];
  grandTotal: Scalars['Int'];
  id: Scalars['ID'];
  items?: Maybe<Array<CartItem>>;
  minimumOrderAmount: Scalars['Int'];
  minimumOrderQuantity: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  store: Store;
  subTotal: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalUniqueItems: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type CartEdge = {
  __typename?: 'CartEdge';
  node?: Maybe<Cart>;
};

export type CartItem = {
  __typename?: 'CartItem';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  lineTotal: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  unit?: Maybe<Scalars['String']>;
  unitQuantity?: Maybe<Scalars['Int']>;
  unitTotal: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  variantName?: Maybe<Scalars['String']>;
};

export type CartsConnection = {
  __typename?: 'CartsConnection';
  edges: Array<Maybe<CartEdge>>;
  id: Scalars['ID'];
};

export type Category = {
  __typename?: 'Category';
  activeCount: Scalars['Int'];
  children?: Maybe<Array<Category>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  producerId: Scalars['ID'];
  totalCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  edges?: Maybe<Array<CategoryEdge>>;
  pageInfo: PageInfo;
};

export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  node: Category;
};

export type ChangeUserPasswordInput = {
  password: Scalars['String'];
  token: Scalars['JWT'];
  userId: Scalars['String'];
};

export type CheckoutAddress = {
  __typename?: 'CheckoutAddress';
  address1: Scalars['String'];
  city: Scalars['String'];
  id: Scalars['ID'];
  province?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type CheckoutOrder = Node & {
  __typename?: 'CheckoutOrder';
  billingAddress?: Maybe<CheckoutAddress>;
  createdAt: Scalars['DateTime'];
  discountTotal: Scalars['Int'];
  financialStatus: FinancialStatus;
  grandTotal: Scalars['Int'];
  hash: Scalars['String'];
  id: Scalars['ID'];
  invoiceUrl?: Maybe<Scalars['String']>;
  lineItems: Array<Maybe<OrderLineItem>>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  producer: Producer;
  refundedTotal: Scalars['Int'];
  serviceFee: Scalars['Int'];
  shipping?: Maybe<CheckoutOrderShipping>;
  shippingAddress?: Maybe<CheckoutAddress>;
  shippingTotal: Scalars['Int'];
  status: OrderStatus;
  subTotal: Scalars['Int'];
  taxTotal: Scalars['Int'];
};

export type CheckoutOrderShipping = {
  __typename?: 'CheckoutOrderShipping';
  date?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  type?: Maybe<OrderShippingType>;
};

export type CheckoutPaymentMethod = {
  __typename?: 'CheckoutPaymentMethod';
  brand?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  type?: Maybe<PaymentMethodType>;
};

export type CompleteCheckoutInput = {
  cartId: Scalars['ID'];
  checkoutId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type CreateCardPaymentMethodInput = {
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};

export type CreateCategoryInput = {
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
};

export type CreateCheckoutInput = {
  checkoutId: Scalars['ID'];
  storeId: Scalars['ID'];
};

export type CreateCheckoutPaymentMethodInput = {
  accountId?: InputMaybe<Scalars['String']>;
  checkoutId: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  paymentMethodType: PaymentMethodType;
  publicToken?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type CreatePlaidPaymentMethodInput = {
  accountId: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  publicToken: Scalars['String'];
};

export type CreateTeamMemberInput = {
  email: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type CreateUserAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  province?: InputMaybe<Scalars['String']>;
  types: Array<AddressType>;
  unit?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type CreateUserInput = {
  company?: InputMaybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  type: CustomerType;
  verifyUrl: Scalars['String'];
};

export type Customer = Node & {
  __typename?: 'Customer';
  accounts: Array<Maybe<CustomerAccount>>;
  billingAddresses: Array<Maybe<CustomerAddress>>;
  companyName?: Maybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shippingAddresses: Array<Maybe<CustomerAddress>>;
  type: CustomerType;
  username?: Maybe<Scalars['String']>;
};

export type CustomerAccount = {
  __typename?: 'CustomerAccount';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastActive?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Latitude']>;
  longitude?: Maybe<Scalars['Longitude']>;
  province?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  edges: Array<Maybe<CustomerEdge>>;
  pageInfo: PageInfo;
};

export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  node: Customer;
};

export enum CustomerType {
  Anonymous = 'ANONYMOUS',
  Retail = 'RETAIL',
  Wholesale = 'WHOLESALE'
}

export type DistanceType = {
  __typename?: 'DistanceType';
  km?: Maybe<Scalars['String']>;
  mi?: Maybe<Scalars['String']>;
};

export enum FinancialStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type Image = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['String']>;
  base64?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  src?: Maybe<Scalars['String']>;
};

export type InitiateResetPasswordInput = {
  email: Scalars['EmailAddress'];
  url: Scalars['String'];
};

export type InitiateResetPasswordResponse = {
  __typename?: 'InitiateResetPasswordResponse';
  email: Scalars['EmailAddress'];
};

export type Location = {
  __typename?: 'Location';
  address1: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  distance?: Maybe<DistanceType>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  latitude?: Maybe<Scalars['Latitude']>;
  longitude?: Maybe<Scalars['Longitude']>;
  marketEnd?: Maybe<Scalars['Int']>;
  marketStart?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  pickupEnd?: Maybe<Scalars['Int']>;
  pickupStart?: Maybe<Scalars['Int']>;
  province?: Maybe<Scalars['String']>;
  until?: Maybe<Scalars['DateTime']>;
  zip?: Maybe<Scalars['PostalCode']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCheckoutDiscount: CheckoutOrder;
  addItem: Cart;
  authenticateWithApple?: Maybe<AccessTokens>;
  authenticateWithCredentials?: Maybe<AccessTokens>;
  authenticateWithFacebook?: Maybe<AccessTokens>;
  authenticateWithGoogle?: Maybe<AccessTokens>;
  categoryCreate: Category;
  changeUserPassword?: Maybe<User>;
  checkoutCreate: CheckoutOrder;
  completeCheckout: CheckoutOrder;
  createCardPaymentMethod: PaymentMethod;
  createCheckoutPaymentMethod: CheckoutOrder;
  createPlaidPaymentMethod: PaymentMethod;
  createTeamMember: User;
  createUser: User;
  createUserAddress?: Maybe<User>;
  deleteCardPaymentMethod: PaymentMethod;
  deleteTeamMember: User;
  deleteUserAddress: User;
  initiateResetPassword: InitiateResetPasswordResponse;
  payOrder: Order;
  productCreate?: Maybe<Product>;
  productUpdate?: Maybe<Product>;
  refreshToken?: Maybe<AccessTokens>;
  removeItem: Cart;
  setItems: Cart;
  unitCreate: Unit;
  updateCheckoutBillingAddress: CheckoutOrder;
  updateCheckoutPaymentMethod: CheckoutOrder;
  updateCheckoutShippingAddress: CheckoutOrder;
  updateCheckoutShippingOption: CheckoutOrder;
  updateDefaultCardPayment: PaymentMethod;
  updateItem: Cart;
  updateTeamMember: User;
  updateUser: User;
  updateUserAddress?: Maybe<User>;
  verifyResetPasswordToken: VerifyResetPasswordTokenResponse;
};


export type MutationAddCheckoutDiscountArgs = {
  input: AddCheckoutDiscountInput;
};


export type MutationAddItemArgs = {
  input: AddToCartInput;
};


export type MutationAuthenticateWithAppleArgs = {
  token: Scalars['String'];
};


export type MutationAuthenticateWithCredentialsArgs = {
  password: Scalars['String'];
  type: UserType;
  username: Scalars['String'];
};


export type MutationAuthenticateWithFacebookArgs = {
  token: Scalars['String'];
};


export type MutationAuthenticateWithGoogleArgs = {
  token: Scalars['String'];
};


export type MutationCategoryCreateArgs = {
  input: CreateCategoryInput;
};


export type MutationChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput;
};


export type MutationCheckoutCreateArgs = {
  input: CreateCheckoutInput;
};


export type MutationCompleteCheckoutArgs = {
  input: CompleteCheckoutInput;
};


export type MutationCreateCardPaymentMethodArgs = {
  input: CreateCardPaymentMethodInput;
};


export type MutationCreateCheckoutPaymentMethodArgs = {
  input: CreateCheckoutPaymentMethodInput;
};


export type MutationCreatePlaidPaymentMethodArgs = {
  input: CreatePlaidPaymentMethodInput;
};


export type MutationCreateTeamMemberArgs = {
  input: CreateTeamMemberInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserAddressArgs = {
  input: CreateUserAddressInput;
};


export type MutationDeleteCardPaymentMethodArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTeamMemberArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserAddressArgs = {
  id: Scalars['ID'];
};


export type MutationInitiateResetPasswordArgs = {
  input: InitiateResetPasswordInput;
};


export type MutationPayOrderArgs = {
  input: PayOrderInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductUpdateArgs = {
  input: ProductUpdateInput;
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRemoveItemArgs = {
  input: RemoveCartItemInput;
};


export type MutationSetItemsArgs = {
  input: SetCartItemsInput;
};


export type MutationUnitCreateArgs = {
  input: UnitCreateInput;
};


export type MutationUpdateCheckoutBillingAddressArgs = {
  input: UpdateCheckoutBillingAddressInput;
};


export type MutationUpdateCheckoutPaymentMethodArgs = {
  input: UpdateCheckoutPaymentMethodInput;
};


export type MutationUpdateCheckoutShippingAddressArgs = {
  input: UpdateCheckoutShippingAddressInput;
};


export type MutationUpdateCheckoutShippingOptionArgs = {
  input: UpdateCheckoutShippingOptionInput;
};


export type MutationUpdateDefaultCardPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateItemArgs = {
  input: UpdateCartItemInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserAddressArgs = {
  input: UpdateUserAddressInput;
};


export type MutationVerifyResetPasswordTokenArgs = {
  input: VerifyResetPasswordTokenInput;
};

export type Node = {
  id: Scalars['ID'];
};

export type Order = Node & {
  __typename?: 'Order';
  createdAt: Scalars['DateTime'];
  customer?: Maybe<OrderCustomer>;
  discountTotal: Scalars['Int'];
  financialStatus: FinancialStatus;
  grandTotal: Scalars['Int'];
  hash: Scalars['String'];
  id: Scalars['ID'];
  invoiceUrl?: Maybe<Scalars['String']>;
  lineItems: Array<Maybe<OrderLineItem>>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  payment: Payment;
  producer: Producer;
  refundedTotal: Scalars['Int'];
  serviceFee: Scalars['Int'];
  shipping: OrderShipping;
  shippingAddress?: Maybe<OrderShippingAddress>;
  shippingTotal: Scalars['Int'];
  status: OrderStatus;
  subTotal: Scalars['Int'];
  taxTotal: Scalars['Int'];
};

export type OrderByInput = {
  createdAt?: InputMaybe<Sort>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  edges: Array<Maybe<OrderEdge>>;
  pageInfo: PageInfo;
};

export type OrderCustomer = {
  __typename?: 'OrderCustomer';
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  type: OrderCustomerType;
};

export enum OrderCustomerType {
  Anonymous = 'ANONYMOUS',
  Retail = 'RETAIL',
  Wholesale = 'WHOLESALE'
}

export type OrderEdge = {
  __typename?: 'OrderEdge';
  node: Order;
};

export type OrderLineItem = Node & {
  __typename?: 'OrderLineItem';
  discountTotal: Scalars['Int'];
  id: Scalars['ID'];
  image?: Maybe<Image>;
  lineTotal: Scalars['Int'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['PositiveInt'];
  unit: Scalars['String'];
  unitPrice: Scalars['Int'];
  unitQuantity: Scalars['PositiveInt'];
  variantId?: Maybe<Scalars['ID']>;
};

export type OrderLineItemConnection = {
  __typename?: 'OrderLineItemConnection';
  edges: Array<Maybe<OrderLineItemEdge>>;
  pageInfo: PageInfo;
};

export type OrderLineItemEdge = {
  __typename?: 'OrderLineItemEdge';
  node?: Maybe<OrderLineItem>;
};

export type OrderLineItemImage = {
  __typename?: 'OrderLineItemImage';
  alt: Scalars['String'];
  base64?: Maybe<Scalars['String']>;
  blurhash?: Maybe<Scalars['String']>;
  src: Scalars['String'];
};

export type OrderShipping = {
  __typename?: 'OrderShipping';
  date?: Maybe<Scalars['DateTime']>;
  fee: Scalars['Int'];
  location?: Maybe<Location>;
  shippingAddress?: Maybe<Scalars['String']>;
  type: OrderShippingType;
};

export type OrderShippingAddress = {
  __typename?: 'OrderShippingAddress';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Latitude']>;
  longitude?: Maybe<Scalars['Longitude']>;
  province?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export enum OrderShippingType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  New = 'NEW',
  NotApproved = 'NOT_APPROVED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Packed = 'PACKED',
  Received = 'RECEIVED'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
};

export type PayOrderInput = {
  hash: Scalars['String'];
  orderId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
};

export type Payment = {
  __typename?: 'Payment';
  completedAt?: Maybe<Scalars['DateTime']>;
  initiatedAt?: Maybe<Scalars['DateTime']>;
  method?: Maybe<PaymentMethod>;
  type: PaymentType;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentMethodType>;
};

export enum PaymentMethodType {
  Cash = 'CASH',
  Check = 'CHECK',
  Cod = 'COD',
  CouponFmnp = 'COUPON_FMNP',
  CouponFreshconnect = 'COUPON_FRESHCONNECT',
  CouponGreenmarketBucks = 'COUPON_GREENMARKET_BUCKS',
  CouponHealthBucks = 'COUPON_HEALTH_BUCKS',
  CouponSnap = 'COUPON_SNAP',
  External = 'EXTERNAL',
  StripeAch = 'STRIPE_ACH',
  StripeCard = 'STRIPE_CARD',
  StripeCardPaymentIntent = 'STRIPE_CARD_PAYMENT_INTENT',
  StripeCardPayworks = 'STRIPE_CARD_PAYWORKS',
  SubscriptionUpfront = 'SUBSCRIPTION_UPFRONT',
  Unknown = 'UNKNOWN'
}

export enum PaymentType {
  Direct = 'DIRECT',
  External = 'EXTERNAL',
  Invoice = 'INVOICE',
  Prepurchase = 'PREPURCHASE',
  Subscription = 'SUBSCRIPTION'
}

export enum PriceLevel {
  Retail = 'retail',
  Wholesale = 'wholesale'
}

export type Producer = {
  __typename?: 'Producer';
  address1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  description?: Maybe<ProducerDescription>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  latitude?: Maybe<Scalars['Latitude']>;
  logo?: Maybe<Image>;
  longitue?: Maybe<Scalars['Longitude']>;
  name: Scalars['String'];
  products: ProductConnection;
  province?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  zip?: Maybe<Scalars['PostalCode']>;
};


export type ProducerProductsArgs = {
  level?: InputMaybe<PriceLevel>;
  options?: InputMaybe<ProductOptionsInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ProducerConnection = {
  __typename?: 'ProducerConnection';
  edges: Array<Maybe<ProducerEdge>>;
  pageInfo: PageInfo;
};

export type ProducerDescription = {
  __typename?: 'ProducerDescription';
  retail?: Maybe<Scalars['String']>;
  wholesale?: Maybe<Scalars['String']>;
};

export type ProducerEdge = {
  __typename?: 'ProducerEdge';
  node?: Maybe<Producer>;
};

export type Product = Node & {
  __typename?: 'Product';
  active: Scalars['Boolean'];
  category?: Maybe<Category>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  name: Scalars['String'];
  producer?: Maybe<Producer>;
  slug?: Maybe<Scalars['String']>;
  subCategory?: Maybe<SubCategory>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants?: Maybe<Array<ProductVariant>>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<Maybe<ProductEdge>>;
  pageInfo: PageInfo;
};

export type ProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<ProductImageInput>;
  name: Scalars['String'];
  subCategoryId?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<ProductCreateVariantInput>>;
};

export type ProductCreateVariantInput = {
  active: ProductVariantActiveInput;
  name: Scalars['String'];
  price?: InputMaybe<ProductVariantPriceInput>;
  unitId?: InputMaybe<Scalars['ID']>;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  node?: Maybe<Product>;
};

export type ProductImageInput = {
  base64: Scalars['String'];
  blurhash: Scalars['String'];
  src: Scalars['String'];
};

export type ProductOptionsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  withImages?: InputMaybe<Scalars['Boolean']>;
};

export type ProductUnit = {
  __typename?: 'ProductUnit';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type ProductUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: InputMaybe<ProductImageInput>;
  name: Scalars['String'];
  subCategoryId?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<ProductUpdateVariantInput>>;
};

export type ProductUpdateVariantInput = {
  active: ProductVariantActiveInput;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ProductVariantPriceInput>;
  unitId?: InputMaybe<Scalars['ID']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  active: ProductVariantActive;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<VariantPrice>;
  type: ProductVariantType;
  unit?: Maybe<ProductUnit>;
};

export type ProductVariantActive = {
  __typename?: 'ProductVariantActive';
  retail?: Maybe<Scalars['Boolean']>;
  wholesale?: Maybe<Scalars['Boolean']>;
};

export type ProductVariantActiveInput = {
  retail: Scalars['Boolean'];
  wholesale: Scalars['Boolean'];
};

export type ProductVariantPriceInput = {
  retail: Scalars['Int'];
  wholesale: Scalars['Int'];
};

export enum ProductVariantType {
  Custom = 'custom',
  Regular = 'regular',
  Subscription = 'subscription',
  VariantBased = 'variant_based'
}

export type Query = {
  __typename?: 'Query';
  cart: Cart;
  carts: CartsConnection;
  categories: CategoryConnection;
  checkout: CheckoutOrder;
  checkoutPaymentMethods: Array<CheckoutPaymentMethod>;
  customer: Customer;
  customers: CustomerConnection;
  order: Order;
  orderItems: Array<Maybe<ReOrderLineItem>>;
  orders: OrderConnection;
  producer: Producer;
  producers: ProducerConnection;
  producersByLocation: ProducerConnection;
  producersFeatured: ProducerConnection;
  product: Product;
  products: ProductConnection;
  shipping: Array<Maybe<ShippingConnection>>;
  units: UnitConnection;
  user?: Maybe<User>;
};


export type QueryCartArgs = {
  id: Scalars['ID'];
  storeId: Scalars['ID'];
};


export type QueryCartsArgs = {
  id: Scalars['ID'];
};


export type QueryCategoriesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCheckoutArgs = {
  id: Scalars['String'];
};


export type QueryCheckoutPaymentMethodsArgs = {
  producerId: Scalars['ID'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderItemsArgs = {
  id: Scalars['ID'];
};


export type QueryOrdersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProducerArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryProducersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProducersByLocationArgs = {
  lat?: InputMaybe<Scalars['Latitude']>;
  lng?: InputMaybe<Scalars['Longitude']>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
  level?: InputMaybe<PriceLevel>;
  options?: InputMaybe<ProductOptionsInput>;
};


export type QueryProductsArgs = {
  level?: InputMaybe<PriceLevel>;
  options?: InputMaybe<ProductOptionsInput>;
  orderBy?: InputMaybe<OrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryShippingArgs = {
  producerId: Scalars['ID'];
};


export type QueryUnitsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type ReOrderLineItem = {
  __typename?: 'ReOrderLineItem';
  available: Scalars['Boolean'];
  category: Scalars['String'];
  id: Scalars['ID'];
  image: OrderLineItemImage;
  lineTotal: Scalars['Int'];
  name: Scalars['String'];
  quantity: Scalars['PositiveInt'];
  subCategory: Scalars['String'];
  unitPrice: Scalars['Int'];
  unitQuantity: Scalars['PositiveInt'];
  variant: ReOrderLineItemVariant;
};

export type ReOrderLineItemVariant = {
  __typename?: 'ReOrderLineItemVariant';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: ProductVariantType;
  unit: Scalars['String'];
};

export type RemoveCartItemInput = {
  cartId: Scalars['ID'];
  id: Scalars['ID'];
  storeId: Scalars['ID'];
};

export type SetCartItemInput = {
  category: Scalars['String'];
  id: Scalars['ID'];
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['Int'];
  quantity?: InputMaybe<Scalars['Int']>;
  subCategory: Scalars['String'];
  type: ProductVariantType;
  unit: Scalars['String'];
  unitQuantity?: InputMaybe<Scalars['Int']>;
  variantName?: InputMaybe<Scalars['String']>;
};

export type SetCartItemsInput = {
  cartId: Scalars['ID'];
  items: Array<SetCartItemInput>;
  storeId: Scalars['ID'];
};

export type Shipping = {
  __typename?: 'Shipping';
  location: Location;
  next: Scalars['DateTime'];
  until: Scalars['DateTime'];
};

export type ShippingConnection = {
  __typename?: 'ShippingConnection';
  edges?: Maybe<Array<Maybe<ShippingEdge>>>;
  type?: Maybe<Scalars['String']>;
};

export type ShippingEdge = {
  __typename?: 'ShippingEdge';
  node: Shipping;
};

export enum ShippingOptionType {
  Delivery = 'delivery',
  Pickup = 'pickup'
}

export enum Sort {
  Asc = 'asc',
  Desc = 'desc'
}

export type Store = {
  __typename?: 'Store';
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type SubCategory = {
  __typename?: 'SubCategory';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Team = {
  __typename?: 'Team';
  avatar?: Maybe<Image>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Unit = {
  __typename?: 'Unit';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UnitConnection = {
  __typename?: 'UnitConnection';
  edges?: Maybe<Array<UnitEdge>>;
  pageInfo: PageInfo;
};

export type UnitCreateInput = {
  name: Scalars['String'];
};

export type UnitEdge = {
  __typename?: 'UnitEdge';
  node: Unit;
};

export type UpdateCartItemInput = {
  cartId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  storeId: Scalars['ID'];
};

export type UpdateCheckoutBillingAddressInput = {
  billingAddressId: Scalars['String'];
  checkoutId: Scalars['ID'];
};

export type UpdateCheckoutPaymentMethodInput = {
  checkoutId: Scalars['ID'];
  paymentMethodId: Scalars['String'];
  paymentMethodType: PaymentMethodType;
};

export type UpdateCheckoutShippingAddressInput = {
  checkoutId: Scalars['ID'];
  shippingAddressId: Scalars['String'];
};

export type UpdateCheckoutShippingOptionInput = {
  checkoutId: Scalars['ID'];
  date: Scalars['DateTime'];
  locationId: Scalars['ID'];
  type: ShippingOptionType;
};

export type UpdateTeamMemberInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UpdateUserAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  id: Scalars['ID'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  province?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type UpdateUserInput = {
  company?: InputMaybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  username: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  accounts?: Maybe<Array<Maybe<Account>>>;
  billingAddresses: Array<UserAddress>;
  createdAt: Scalars['DateTime'];
  email: Scalars['EmailAddress'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  level?: Maybe<CustomerType>;
  paymentMethods: Array<Maybe<PaymentMethod>>;
  phone?: Maybe<Scalars['String']>;
  shippingAddresses: Array<UserAddress>;
  team?: Maybe<Team>;
  type: UserType;
  username: Scalars['String'];
};


export type UserPaymentMethodsArgs = {
  producerId?: InputMaybe<Scalars['ID']>;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  province?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export enum UserType {
  Customer = 'CUSTOMER',
  Producer = 'PRODUCER'
}

export type VariantPrice = {
  __typename?: 'VariantPrice';
  retail?: Maybe<Scalars['Int']>;
  wholesale?: Maybe<Scalars['Int']>;
};

export type VerifyResetPasswordTokenInput = {
  token: Scalars['String'];
  userId: Scalars['String'];
};

export type VerifyResetPasswordTokenResponse = {
  __typename?: 'VerifyResetPasswordTokenResponse';
  authenticationToken: Scalars['JWT'];
  changePasswordToken: Scalars['JWT'];
  user: User;
};

export type CartFragmentFragment = { __typename?: 'Cart', id: string, totalUniqueItems: number, grandTotal: number, subTotal: number, notes?: string | null, createdAt: any, updatedAt: any, minimumOrderAmount: number, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null, lineTotal: number, name?: string | null, variantName?: string | null, notes?: string | null, quantity: number, unitQuantity?: number | null, unit?: string | null, unitTotal: number }> | null };

export type CartQueryVariables = Exact<{
  id: Scalars['ID'];
  storeId: Scalars['ID'];
}>;


export type CartQuery = { __typename?: 'Query', cart: { __typename?: 'Cart', id: string, totalUniqueItems: number, grandTotal: number, subTotal: number, notes?: string | null, createdAt: any, updatedAt: any, minimumOrderAmount: number, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null, lineTotal: number, name?: string | null, variantName?: string | null, notes?: string | null, quantity: number, unitQuantity?: number | null, unit?: string | null, unitTotal: number }> | null } };

export type CartsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CartsQuery = { __typename?: 'Query', carts: { __typename?: 'CartsConnection', id: string, edges: Array<{ __typename?: 'CartEdge', node?: { __typename?: 'Cart', id: string, store: { __typename?: 'Store', id: string, slug: string, name: string, logo?: string | null }, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null }> | null } | null } | null> } };

export type AddCartItemMutationVariables = Exact<{
  input: AddToCartInput;
}>;


export type AddCartItemMutation = { __typename?: 'Mutation', addItem: { __typename?: 'Cart', id: string, totalUniqueItems: number, grandTotal: number, subTotal: number, notes?: string | null, createdAt: any, updatedAt: any, minimumOrderAmount: number, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null, lineTotal: number, name?: string | null, variantName?: string | null, notes?: string | null, quantity: number, unitQuantity?: number | null, unit?: string | null, unitTotal: number }> | null } };

export type RemoveCartItemMutationVariables = Exact<{
  input: RemoveCartItemInput;
}>;


export type RemoveCartItemMutation = { __typename?: 'Mutation', removeItem: { __typename?: 'Cart', id: string, totalUniqueItems: number, grandTotal: number, subTotal: number, notes?: string | null, createdAt: any, updatedAt: any, minimumOrderAmount: number, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null, lineTotal: number, name?: string | null, variantName?: string | null, notes?: string | null, quantity: number, unitQuantity?: number | null, unit?: string | null, unitTotal: number }> | null } };

export type UpdateCartItemMutationVariables = Exact<{
  input: UpdateCartItemInput;
}>;


export type UpdateCartItemMutation = { __typename?: 'Mutation', updateItem: { __typename?: 'Cart', id: string, totalUniqueItems: number, grandTotal: number, subTotal: number, notes?: string | null, createdAt: any, updatedAt: any, minimumOrderAmount: number, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null, lineTotal: number, name?: string | null, variantName?: string | null, notes?: string | null, quantity: number, unitQuantity?: number | null, unit?: string | null, unitTotal: number }> | null } };

export type SetCartItemsMutationVariables = Exact<{
  input: SetCartItemsInput;
}>;


export type SetCartItemsMutation = { __typename?: 'Mutation', setItems: { __typename?: 'Cart', id: string, totalUniqueItems: number, grandTotal: number, subTotal: number, notes?: string | null, createdAt: any, updatedAt: any, minimumOrderAmount: number, items?: Array<{ __typename?: 'CartItem', id: string, image?: string | null, lineTotal: number, name?: string | null, variantName?: string | null, notes?: string | null, quantity: number, unitQuantity?: number | null, unit?: string | null, unitTotal: number }> | null } };

export type CheckoutFragmentFragment = { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> };

export type CheckoutQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CheckoutQuery = { __typename?: 'Query', checkout: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type CheckoutPaymentMethodsQueryVariables = Exact<{
  producerId: Scalars['ID'];
}>;


export type CheckoutPaymentMethodsQuery = { __typename?: 'Query', checkoutPaymentMethods: Array<{ __typename?: 'CheckoutPaymentMethod', id: string, name: string, brand?: string | null, type?: PaymentMethodType | null }> };

export type CheckoutUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, phone?: string | null, paymentMethods: Array<{ __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null>, shippingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, city: string, isDefault: boolean, province?: string | null, zip: string }>, billingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, city: string, isDefault: boolean, province?: string | null, zip: string }> } | null };

export type CheckoutCreateMutationVariables = Exact<{
  input: CreateCheckoutInput;
}>;


export type CheckoutCreateMutation = { __typename?: 'Mutation', checkoutCreate: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type UpdateCheckoutShippingOptionMutationVariables = Exact<{
  input: UpdateCheckoutShippingOptionInput;
}>;


export type UpdateCheckoutShippingOptionMutation = { __typename?: 'Mutation', updateCheckoutShippingOption: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type UpdateCheckoutPaymentMethodMutationVariables = Exact<{
  input: UpdateCheckoutPaymentMethodInput;
}>;


export type UpdateCheckoutPaymentMethodMutation = { __typename?: 'Mutation', updateCheckoutPaymentMethod: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type CompleteCheckoutMutationVariables = Exact<{
  input: CompleteCheckoutInput;
}>;


export type CompleteCheckoutMutation = { __typename?: 'Mutation', completeCheckout: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type CreateCheckoutPaymentMethodMutationVariables = Exact<{
  input: CreateCheckoutPaymentMethodInput;
}>;


export type CreateCheckoutPaymentMethodMutation = { __typename?: 'Mutation', createCheckoutPaymentMethod: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type UpdateCheckoutShippingAddressMutationVariables = Exact<{
  input: UpdateCheckoutShippingAddressInput;
}>;


export type UpdateCheckoutShippingAddressMutation = { __typename?: 'Mutation', updateCheckoutShippingAddress: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type UpdateCheckoutBillingAddressMutationVariables = Exact<{
  input: UpdateCheckoutBillingAddressInput;
}>;


export type UpdateCheckoutBillingAddressMutation = { __typename?: 'Mutation', updateCheckoutBillingAddress: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type AddCheckoutDiscountMutationVariables = Exact<{
  input: AddCheckoutDiscountInput;
}>;


export type AddCheckoutDiscountMutation = { __typename?: 'Mutation', addCheckoutDiscount: { __typename?: 'CheckoutOrder', id: string, grandTotal: number, shippingTotal: number, subTotal: number, discountTotal: number, serviceFee: number, producer: { __typename?: 'Producer', id: string }, shipping?: { __typename?: 'CheckoutOrderShipping', date?: any | null, type?: OrderShippingType | null, location?: { __typename?: 'Location', id: string } | null } | null, payment?: { __typename?: 'Payment', method?: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null } | null, shippingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, billingAddress?: { __typename?: 'CheckoutAddress', id: string, address1: string, city: string, province?: string | null, zip: string } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type OrderFragmentFragment = { __typename?: 'Order', id: string, hash: string, status: OrderStatus, name: string, note?: string | null, taxTotal: number, grandTotal: number, discountTotal: number, refundedTotal: number, invoiceUrl?: string | null, subTotal: number, shippingTotal: number, serviceFee: number, financialStatus: FinancialStatus, producer: { __typename?: 'Producer', id: string, slug: string, name: string, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null }, payment: { __typename?: 'Payment', completedAt?: any | null, initiatedAt?: any | null, method?: { __typename?: 'PaymentMethod', id?: string | null, name?: string | null, brand?: string | null, type?: PaymentMethodType | null } | null }, shipping: { __typename?: 'OrderShipping', type: OrderShippingType, date?: any | null, location?: { __typename?: 'Location', name: string, latitude?: any | null, longitude?: any | null, address1: string, city?: string | null, province?: string | null, zip?: any | null, image?: { __typename?: 'Image', src?: string | null } | null } | null }, shippingAddress?: { __typename?: 'OrderShippingAddress', address1: string, city: string, zip: string, longitude?: any | null, latitude?: any | null, province?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> };

export type OrdersQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'Order', id: string, name: string, status: OrderStatus, financialStatus: FinancialStatus, grandTotal: number, producer: { __typename?: 'Producer', name: string, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null }, shipping: { __typename?: 'OrderShipping', type: OrderShippingType, date?: any | null } } } | null> } };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, hash: string, status: OrderStatus, name: string, note?: string | null, taxTotal: number, grandTotal: number, discountTotal: number, refundedTotal: number, invoiceUrl?: string | null, subTotal: number, shippingTotal: number, serviceFee: number, financialStatus: FinancialStatus, producer: { __typename?: 'Producer', id: string, slug: string, name: string, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null }, payment: { __typename?: 'Payment', completedAt?: any | null, initiatedAt?: any | null, method?: { __typename?: 'PaymentMethod', id?: string | null, name?: string | null, brand?: string | null, type?: PaymentMethodType | null } | null }, shipping: { __typename?: 'OrderShipping', type: OrderShippingType, date?: any | null, location?: { __typename?: 'Location', name: string, latitude?: any | null, longitude?: any | null, address1: string, city?: string | null, province?: string | null, zip?: any | null, image?: { __typename?: 'Image', src?: string | null } | null } | null }, shippingAddress?: { __typename?: 'OrderShippingAddress', address1: string, city: string, zip: string, longitude?: any | null, latitude?: any | null, province?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type PayOrderMutationVariables = Exact<{
  input: PayOrderInput;
}>;


export type PayOrderMutation = { __typename?: 'Mutation', payOrder: { __typename?: 'Order', id: string, hash: string, status: OrderStatus, name: string, note?: string | null, taxTotal: number, grandTotal: number, discountTotal: number, refundedTotal: number, invoiceUrl?: string | null, subTotal: number, shippingTotal: number, serviceFee: number, financialStatus: FinancialStatus, producer: { __typename?: 'Producer', id: string, slug: string, name: string, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null }, payment: { __typename?: 'Payment', completedAt?: any | null, initiatedAt?: any | null, method?: { __typename?: 'PaymentMethod', id?: string | null, name?: string | null, brand?: string | null, type?: PaymentMethodType | null } | null }, shipping: { __typename?: 'OrderShipping', type: OrderShippingType, date?: any | null, location?: { __typename?: 'Location', name: string, latitude?: any | null, longitude?: any | null, address1: string, city?: string | null, province?: string | null, zip?: any | null, image?: { __typename?: 'Image', src?: string | null } | null } | null }, shippingAddress?: { __typename?: 'OrderShippingAddress', address1: string, city: string, zip: string, longitude?: any | null, latitude?: any | null, province?: string | null } | null, lineItems: Array<{ __typename?: 'OrderLineItem', id: string, name: string, unit: string, quantity: any, unitQuantity: any, lineTotal: number, note?: string | null, discountTotal: number, image?: { __typename?: 'Image', src?: string | null } | null } | null> } };

export type OrderItemsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderItemsQuery = { __typename?: 'Query', order: { __typename?: 'Order', id: string, name: string, producer: { __typename?: 'Producer', slug: string } }, orderItems: Array<{ __typename?: 'ReOrderLineItem', id: string, name: string, available: boolean, category: string, subCategory: string, quantity: any, unitQuantity: any, unitPrice: number, variant: { __typename?: 'ReOrderLineItemVariant', name: string, unit: string, type: ProductVariantType }, image: { __typename?: 'OrderLineItemImage', src: string, base64?: string | null, blurhash?: string | null, alt: string } } | null> };

export type PaymentMethodFragmentFragment = { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null };

export type CreatePlaidPaymentMethodMutationVariables = Exact<{
  input: CreatePlaidPaymentMethodInput;
}>;


export type CreatePlaidPaymentMethodMutation = { __typename?: 'Mutation', createPlaidPaymentMethod: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } };

export type CreateCardPaymentMethodMutationVariables = Exact<{
  input: CreateCardPaymentMethodInput;
}>;


export type CreateCardPaymentMethodMutation = { __typename?: 'Mutation', createCardPaymentMethod: { __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } };

export type UpdateDefaultCardPaymentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateDefaultCardPaymentMutation = { __typename?: 'Mutation', updateDefaultCardPayment: { __typename?: 'PaymentMethod', id?: string | null } };

export type DeleteCardPaymentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCardPaymentMutation = { __typename?: 'Mutation', deleteCardPaymentMethod: { __typename?: 'PaymentMethod', id?: string | null } };

export type ProducerIdsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
}>;


export type ProducerIdsQuery = { __typename?: 'Query', producers: { __typename?: 'ProducerConnection', edges: Array<{ __typename?: 'ProducerEdge', node?: { __typename?: 'Producer', slug: string } | null } | null> } };

export type ProducerQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<PriceLevel>;
}>;


export type ProducerQuery = { __typename?: 'Query', producer: { __typename?: 'Producer', id: string, name: string, slug: string, city?: string | null, province?: string | null, description?: { __typename?: 'ProducerDescription', retail?: string | null, wholesale?: string | null } | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node?: { __typename?: 'Product', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, active: { __typename?: 'ProductVariantActive', wholesale?: boolean | null, retail?: boolean | null }, price?: { __typename?: 'VariantPrice', wholesale?: number | null, retail?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null, quantity: number } | null }> | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null } | null } | null> } } };

export type ProducerPopularFragmentFragment = { __typename?: 'Producer', id: string, name: string, city?: string | null, province?: string | null, slug: string, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node?: { __typename?: 'Product', id: string, name: string, slug?: string | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, price?: { __typename?: 'VariantPrice', retail?: number | null, wholesale?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null } | null }> | null } | null } | null> } };

export type ProducersPopularQueryVariables = Exact<{ [key: string]: never; }>;


export type ProducersPopularQuery = { __typename?: 'Query', mountain: { __typename?: 'Producer', id: string, name: string, city?: string | null, province?: string | null, slug: string, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node?: { __typename?: 'Product', id: string, name: string, slug?: string | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, price?: { __typename?: 'VariantPrice', retail?: number | null, wholesale?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null } | null }> | null } | null } | null> } }, norwich: { __typename?: 'Producer', id: string, name: string, city?: string | null, province?: string | null, slug: string, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node?: { __typename?: 'Product', id: string, name: string, slug?: string | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, price?: { __typename?: 'VariantPrice', retail?: number | null, wholesale?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null } | null }> | null } | null } | null> } }, tonjes: { __typename?: 'Producer', id: string, name: string, city?: string | null, province?: string | null, slug: string, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node?: { __typename?: 'Product', id: string, name: string, slug?: string | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, price?: { __typename?: 'VariantPrice', retail?: number | null, wholesale?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null } | null }> | null } | null } | null> } } };

export type ProducersByLocationQueryVariables = Exact<{
  lat?: InputMaybe<Scalars['Latitude']>;
  lng?: InputMaybe<Scalars['Longitude']>;
}>;


export type ProducersByLocationQuery = { __typename?: 'Query', producersByLocation: { __typename?: 'ProducerConnection', edges: Array<{ __typename?: 'ProducerEdge', node?: { __typename?: 'Producer', id: string, name: string, city?: string | null, province?: string | null, slug: string, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null } | null } | null> } };

export type ProducersFeaturedQueryVariables = Exact<{ [key: string]: never; }>;


export type ProducersFeaturedQuery = { __typename?: 'Query', producersFeatured: { __typename?: 'ProducerConnection', edges: Array<{ __typename?: 'ProducerEdge', node?: { __typename?: 'Producer', id: string, name: string, city?: string | null, province?: string | null, slug: string, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null } | null } | null> } };

export type ProductNodeFragment = { __typename?: 'Product', id: string, name: string, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, active: { __typename?: 'ProductVariantActive', wholesale?: boolean | null, retail?: boolean | null }, price?: { __typename?: 'VariantPrice', wholesale?: number | null, retail?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null, quantity: number } | null }> | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null };

export type PreRenderProductsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<PriceLevel>;
}>;


export type PreRenderProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductConnection', edges: Array<{ __typename?: 'ProductEdge', node?: { __typename?: 'Product', id: string, producer?: { __typename?: 'Producer', slug: string } | null } | null } | null> } };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID'];
  level?: InputMaybe<PriceLevel>;
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', description?: string | null, id: string, name: string, producer?: { __typename?: 'Producer', name: string, city?: string | null, province?: string | null, slug: string, description?: { __typename?: 'ProducerDescription', retail?: string | null, wholesale?: string | null } | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null, logo?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null } | null, category?: { __typename?: 'Category', id: string, name: string } | null, subCategory?: { __typename?: 'SubCategory', id?: string | null, name?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, type: ProductVariantType, active: { __typename?: 'ProductVariantActive', wholesale?: boolean | null, retail?: boolean | null }, price?: { __typename?: 'VariantPrice', wholesale?: number | null, retail?: number | null } | null, unit?: { __typename?: 'ProductUnit', name?: string | null, quantity: number } | null }> | null, image?: { __typename?: 'Image', src?: string | null, base64?: string | null } | null } };

export type ShippingQueryVariables = Exact<{
  producerId: Scalars['ID'];
}>;


export type ShippingQuery = { __typename?: 'Query', shipping: Array<{ __typename?: 'ShippingConnection', type?: string | null, edges?: Array<{ __typename?: 'ShippingEdge', node: { __typename?: 'Shipping', next: any, until: any, location: { __typename?: 'Location', id: string, name: string, address1: string, city?: string | null, province?: string | null, zip?: any | null, pickupStart?: number | null, pickupEnd?: number | null, image?: { __typename?: 'Image', src?: string | null } | null } } } | null> | null } | null> };

export type UserAddressFragmentFragment = { __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string };

export type UserFragmentFragment = { __typename?: 'User', id: string, firstName?: string | null, username: string, lastName?: string | null, createdAt: any, phone?: string | null, email: any, team?: { __typename?: 'Team', name?: string | null } | null };

export type UserTeamMembersFragmentFragment = { __typename?: 'User', id: string, accounts?: Array<{ __typename?: 'Account', id: string, email: any, firstName?: string | null, lastName?: string | null, createdAt: any, lastActive?: any | null } | null> | null };

export type AccountUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName?: string | null, username: string, lastName?: string | null, createdAt: any, phone?: string | null, email: any, shippingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }>, billingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }>, team?: { __typename?: 'Team', name?: string | null } | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, firstName?: string | null, email: any, team?: { __typename?: 'Team', name?: string | null } | null } | null };

export type UserTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTeamMembersQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, accounts?: Array<{ __typename?: 'Account', id: string, email: any, firstName?: string | null, lastName?: string | null, createdAt: any, lastActive?: any | null } | null> | null } | null };

export type UserPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPaymentMethodsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, paymentMethods: Array<{ __typename?: 'PaymentMethod', id?: string | null, brand?: string | null, isDefault?: boolean | null, name?: string | null, description?: string | null, type?: PaymentMethodType | null } | null> } | null };

export type UserAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAddressesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, shippingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }>, billingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }> } | null };

export type CreateUserAddressMutationVariables = Exact<{
  input: CreateUserAddressInput;
}>;


export type CreateUserAddressMutation = { __typename?: 'Mutation', createUserAddress?: { __typename?: 'User', id: string, shippingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }>, billingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }> } | null };

export type DeleteUserAddressMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserAddressMutation = { __typename?: 'Mutation', deleteUserAddress: { __typename?: 'User', id: string, shippingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }>, billingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }> } };

export type InitiateResetPasswordMutationVariables = Exact<{
  input: InitiateResetPasswordInput;
}>;


export type InitiateResetPasswordMutation = { __typename?: 'Mutation', initiateResetPassword: { __typename?: 'InitiateResetPasswordResponse', email: any } };

export type VerifyResetPasswordTokenMutationVariables = Exact<{
  input: VerifyResetPasswordTokenInput;
}>;


export type VerifyResetPasswordTokenMutation = { __typename?: 'Mutation', verifyResetPasswordToken: { __typename?: 'VerifyResetPasswordTokenResponse', changePasswordToken: any, authenticationToken: any, user: { __typename?: 'User', id: string } } };

export type ChangeUserPasswordMutationVariables = Exact<{
  input: ChangeUserPasswordInput;
}>;


export type ChangeUserPasswordMutation = { __typename?: 'Mutation', changeUserPassword?: { __typename?: 'User', email: any } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', email: any } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName?: string | null, username: string, lastName?: string | null, createdAt: any, phone?: string | null, email: any, team?: { __typename?: 'Team', name?: string | null } | null } };

export type UpdateUserAddressMutationVariables = Exact<{
  input: UpdateUserAddressInput;
}>;


export type UpdateUserAddressMutation = { __typename?: 'Mutation', updateUserAddress?: { __typename?: 'User', id: string, shippingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }>, billingAddresses: Array<{ __typename?: 'UserAddress', id: string, address1: string, address2?: string | null, city: string, isDefault: boolean, province?: string | null, zip: string }> } | null };

export type CreateTeamMemberMutationVariables = Exact<{
  input: CreateTeamMemberInput;
}>;


export type CreateTeamMemberMutation = { __typename?: 'Mutation', createTeamMember: { __typename?: 'User', id: string, accounts?: Array<{ __typename?: 'Account', id: string, email: any, firstName?: string | null, lastName?: string | null, createdAt: any, lastActive?: any | null } | null> | null } };

export type UpdateTeamMemberMutationVariables = Exact<{
  input: UpdateTeamMemberInput;
}>;


export type UpdateTeamMemberMutation = { __typename?: 'Mutation', updateTeamMember: { __typename?: 'User', id: string, accounts?: Array<{ __typename?: 'Account', id: string, email: any, firstName?: string | null, lastName?: string | null, createdAt: any, lastActive?: any | null } | null> | null } };

export type DeleteTeamMemberMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', deleteTeamMember: { __typename?: 'User', id: string, accounts?: Array<{ __typename?: 'Account', id: string, email: any, firstName?: string | null, lastName?: string | null, createdAt: any, lastActive?: any | null } | null> | null } };

export const CartFragmentFragmentDoc = gql`
    fragment CartFragment on Cart {
  id
  totalUniqueItems
  grandTotal
  subTotal
  items {
    id
    image
    lineTotal
    name
    variantName
    notes
    quantity
    unitQuantity
    unit
    unitTotal
  }
  notes
  createdAt
  updatedAt
  minimumOrderAmount
}
    `;
export const PaymentMethodFragmentFragmentDoc = gql`
    fragment PaymentMethodFragment on PaymentMethod {
  id
  brand
  isDefault
  name
  description
  type
}
    `;
export const CheckoutFragmentFragmentDoc = gql`
    fragment CheckoutFragment on CheckoutOrder {
  id
  grandTotal
  shippingTotal
  subTotal
  discountTotal
  serviceFee
  producer {
    id
  }
  shipping {
    date
    type
    location {
      id
    }
  }
  payment {
    method {
      ...PaymentMethodFragment
    }
  }
  shippingAddress {
    id
    address1
    city
    province
    zip
  }
  billingAddress {
    id
    address1
    city
    province
    zip
  }
  lineItems {
    id
    name
    unit
    quantity
    unitQuantity
    lineTotal
    note
    discountTotal
    image {
      src
    }
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  id
  hash
  status
  name
  note
  taxTotal
  grandTotal
  discountTotal
  refundedTotal
  invoiceUrl
  subTotal
  shippingTotal
  serviceFee
  financialStatus
  producer {
    id
    slug
    name
    image {
      src
      base64
    }
    logo {
      src
      base64
    }
  }
  payment {
    completedAt
    initiatedAt
    method {
      id
      name
      brand
      type
    }
  }
  shipping {
    type
    date
    location {
      name
      latitude
      longitude
      address1
      city
      province
      zip
      image {
        src
      }
    }
  }
  shippingAddress {
    address1
    city
    zip
    longitude
    latitude
    province
  }
  lineItems {
    id
    name
    unit
    quantity
    unitQuantity
    lineTotal
    note
    discountTotal
    image {
      src
    }
  }
}
    `;
export const ProducerPopularFragmentFragmentDoc = gql`
    fragment ProducerPopularFragment on Producer {
  id
  name
  city
  province
  logo {
    src
    base64
  }
  slug
  products(take: 4, options: {withImages: true}) {
    edges {
      node {
        id
        name
        image {
          src
          base64
        }
        slug
        category {
          id
          name
        }
        subCategory {
          id
          name
        }
        variants {
          id
          name
          price {
            retail
            wholesale
          }
          unit {
            name
          }
          type
        }
      }
    }
  }
}
    `;
export const ProductNodeFragmentDoc = gql`
    fragment ProductNode on Product {
  id
  name
  category {
    id
    name
  }
  subCategory {
    id
    name
  }
  variants {
    id
    active {
      wholesale
      retail
    }
    price {
      wholesale
      retail
    }
    unit {
      name
      quantity
    }
    name
    type
  }
  image {
    src
    base64
  }
}
    `;
export const UserAddressFragmentFragmentDoc = gql`
    fragment UserAddressFragment on UserAddress {
  id
  address1
  address2
  city
  isDefault
  province
  zip
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  firstName
  username
  lastName
  createdAt
  phone
  email
  team {
    name
  }
}
    `;
export const UserTeamMembersFragmentFragmentDoc = gql`
    fragment UserTeamMembersFragment on User {
  id
  accounts {
    id
    email
    firstName
    lastName
    createdAt
    lastActive
  }
}
    `;
export const CartDocument = gql`
    query Cart($id: ID!, $storeId: ID!) {
  cart(id: $id, storeId: $storeId) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *      id: // value for 'id'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useCartQuery(baseOptions: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export const CartsDocument = gql`
    query Carts($id: ID!) {
  carts(id: $id) {
    id
    edges {
      node {
        id
        store {
          id
          slug
          name
          logo
        }
        items {
          id
          image
        }
      }
    }
  }
}
    `;

/**
 * __useCartsQuery__
 *
 * To run a query within a React component, call `useCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartsQuery(baseOptions: Apollo.QueryHookOptions<CartsQuery, CartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
      }
export function useCartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartsQuery, CartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartsQuery, CartsQueryVariables>(CartsDocument, options);
        }
export type CartsQueryHookResult = ReturnType<typeof useCartsQuery>;
export type CartsLazyQueryHookResult = ReturnType<typeof useCartsLazyQuery>;
export type CartsQueryResult = Apollo.QueryResult<CartsQuery, CartsQueryVariables>;
export const AddCartItemDocument = gql`
    mutation AddCartItem($input: AddToCartInput!) {
  addItem(input: $input) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export type AddCartItemMutationFn = Apollo.MutationFunction<AddCartItemMutation, AddCartItemMutationVariables>;

/**
 * __useAddCartItemMutation__
 *
 * To run a mutation, you first call `useAddCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCartItemMutation, { data, loading, error }] = useAddCartItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCartItemMutation(baseOptions?: Apollo.MutationHookOptions<AddCartItemMutation, AddCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCartItemMutation, AddCartItemMutationVariables>(AddCartItemDocument, options);
      }
export type AddCartItemMutationHookResult = ReturnType<typeof useAddCartItemMutation>;
export type AddCartItemMutationResult = Apollo.MutationResult<AddCartItemMutation>;
export type AddCartItemMutationOptions = Apollo.BaseMutationOptions<AddCartItemMutation, AddCartItemMutationVariables>;
export const RemoveCartItemDocument = gql`
    mutation RemoveCartItem($input: RemoveCartItemInput!) {
  removeItem(input: $input) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export type RemoveCartItemMutationFn = Apollo.MutationFunction<RemoveCartItemMutation, RemoveCartItemMutationVariables>;

/**
 * __useRemoveCartItemMutation__
 *
 * To run a mutation, you first call `useRemoveCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCartItemMutation, { data, loading, error }] = useRemoveCartItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCartItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCartItemMutation, RemoveCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCartItemMutation, RemoveCartItemMutationVariables>(RemoveCartItemDocument, options);
      }
export type RemoveCartItemMutationHookResult = ReturnType<typeof useRemoveCartItemMutation>;
export type RemoveCartItemMutationResult = Apollo.MutationResult<RemoveCartItemMutation>;
export type RemoveCartItemMutationOptions = Apollo.BaseMutationOptions<RemoveCartItemMutation, RemoveCartItemMutationVariables>;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($input: UpdateCartItemInput!) {
  updateItem(input: $input) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export type UpdateCartItemMutationFn = Apollo.MutationFunction<UpdateCartItemMutation, UpdateCartItemMutationVariables>;

/**
 * __useUpdateCartItemMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemMutation, { data, loading, error }] = useUpdateCartItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCartItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemMutation, UpdateCartItemMutationVariables>(UpdateCartItemDocument, options);
      }
export type UpdateCartItemMutationHookResult = ReturnType<typeof useUpdateCartItemMutation>;
export type UpdateCartItemMutationResult = Apollo.MutationResult<UpdateCartItemMutation>;
export type UpdateCartItemMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>;
export const SetCartItemsDocument = gql`
    mutation SetCartItems($input: SetCartItemsInput!) {
  setItems(input: $input) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export type SetCartItemsMutationFn = Apollo.MutationFunction<SetCartItemsMutation, SetCartItemsMutationVariables>;

/**
 * __useSetCartItemsMutation__
 *
 * To run a mutation, you first call `useSetCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCartItemsMutation, { data, loading, error }] = useSetCartItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCartItemsMutation(baseOptions?: Apollo.MutationHookOptions<SetCartItemsMutation, SetCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCartItemsMutation, SetCartItemsMutationVariables>(SetCartItemsDocument, options);
      }
export type SetCartItemsMutationHookResult = ReturnType<typeof useSetCartItemsMutation>;
export type SetCartItemsMutationResult = Apollo.MutationResult<SetCartItemsMutation>;
export type SetCartItemsMutationOptions = Apollo.BaseMutationOptions<SetCartItemsMutation, SetCartItemsMutationVariables>;
export const CheckoutDocument = gql`
    query Checkout($id: String!) {
  checkout(id: $id) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions: Apollo.QueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<CheckoutQuery, CheckoutQueryVariables>;
export const CheckoutPaymentMethodsDocument = gql`
    query CheckoutPaymentMethods($producerId: ID!) {
  checkoutPaymentMethods(producerId: $producerId) {
    id
    name
    brand
    type
  }
}
    `;

/**
 * __useCheckoutPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCheckoutPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPaymentMethodsQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useCheckoutPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>(CheckoutPaymentMethodsDocument, options);
      }
export function useCheckoutPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>(CheckoutPaymentMethodsDocument, options);
        }
export type CheckoutPaymentMethodsQueryHookResult = ReturnType<typeof useCheckoutPaymentMethodsQuery>;
export type CheckoutPaymentMethodsLazyQueryHookResult = ReturnType<typeof useCheckoutPaymentMethodsLazyQuery>;
export type CheckoutPaymentMethodsQueryResult = Apollo.QueryResult<CheckoutPaymentMethodsQuery, CheckoutPaymentMethodsQueryVariables>;
export const CheckoutUserDocument = gql`
    query CheckoutUser {
  user {
    id
    phone
    paymentMethods {
      ...PaymentMethodFragment
    }
    shippingAddresses {
      id
      address1
      city
      isDefault
      province
      zip
    }
    billingAddresses {
      id
      address1
      city
      isDefault
      province
      zip
    }
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;

/**
 * __useCheckoutUserQuery__
 *
 * To run a query within a React component, call `useCheckoutUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutUserQuery(baseOptions?: Apollo.QueryHookOptions<CheckoutUserQuery, CheckoutUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutUserQuery, CheckoutUserQueryVariables>(CheckoutUserDocument, options);
      }
export function useCheckoutUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutUserQuery, CheckoutUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutUserQuery, CheckoutUserQueryVariables>(CheckoutUserDocument, options);
        }
export type CheckoutUserQueryHookResult = ReturnType<typeof useCheckoutUserQuery>;
export type CheckoutUserLazyQueryHookResult = ReturnType<typeof useCheckoutUserLazyQuery>;
export type CheckoutUserQueryResult = Apollo.QueryResult<CheckoutUserQuery, CheckoutUserQueryVariables>;
export const CheckoutCreateDocument = gql`
    mutation CheckoutCreate($input: CreateCheckoutInput!) {
  checkoutCreate(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type CheckoutCreateMutationFn = Apollo.MutationFunction<CheckoutCreateMutation, CheckoutCreateMutationVariables>;

/**
 * __useCheckoutCreateMutation__
 *
 * To run a mutation, you first call `useCheckoutCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCreateMutation, { data, loading, error }] = useCheckoutCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutCreateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutCreateMutation, CheckoutCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutCreateMutation, CheckoutCreateMutationVariables>(CheckoutCreateDocument, options);
      }
export type CheckoutCreateMutationHookResult = ReturnType<typeof useCheckoutCreateMutation>;
export type CheckoutCreateMutationResult = Apollo.MutationResult<CheckoutCreateMutation>;
export type CheckoutCreateMutationOptions = Apollo.BaseMutationOptions<CheckoutCreateMutation, CheckoutCreateMutationVariables>;
export const UpdateCheckoutShippingOptionDocument = gql`
    mutation UpdateCheckoutShippingOption($input: UpdateCheckoutShippingOptionInput!) {
  updateCheckoutShippingOption(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type UpdateCheckoutShippingOptionMutationFn = Apollo.MutationFunction<UpdateCheckoutShippingOptionMutation, UpdateCheckoutShippingOptionMutationVariables>;

/**
 * __useUpdateCheckoutShippingOptionMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutShippingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutShippingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutShippingOptionMutation, { data, loading, error }] = useUpdateCheckoutShippingOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutShippingOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutShippingOptionMutation, UpdateCheckoutShippingOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutShippingOptionMutation, UpdateCheckoutShippingOptionMutationVariables>(UpdateCheckoutShippingOptionDocument, options);
      }
export type UpdateCheckoutShippingOptionMutationHookResult = ReturnType<typeof useUpdateCheckoutShippingOptionMutation>;
export type UpdateCheckoutShippingOptionMutationResult = Apollo.MutationResult<UpdateCheckoutShippingOptionMutation>;
export type UpdateCheckoutShippingOptionMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutShippingOptionMutation, UpdateCheckoutShippingOptionMutationVariables>;
export const UpdateCheckoutPaymentMethodDocument = gql`
    mutation UpdateCheckoutPaymentMethod($input: UpdateCheckoutPaymentMethodInput!) {
  updateCheckoutPaymentMethod(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type UpdateCheckoutPaymentMethodMutationFn = Apollo.MutationFunction<UpdateCheckoutPaymentMethodMutation, UpdateCheckoutPaymentMethodMutationVariables>;

/**
 * __useUpdateCheckoutPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutPaymentMethodMutation, { data, loading, error }] = useUpdateCheckoutPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutPaymentMethodMutation, UpdateCheckoutPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutPaymentMethodMutation, UpdateCheckoutPaymentMethodMutationVariables>(UpdateCheckoutPaymentMethodDocument, options);
      }
export type UpdateCheckoutPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCheckoutPaymentMethodMutation>;
export type UpdateCheckoutPaymentMethodMutationResult = Apollo.MutationResult<UpdateCheckoutPaymentMethodMutation>;
export type UpdateCheckoutPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutPaymentMethodMutation, UpdateCheckoutPaymentMethodMutationVariables>;
export const CompleteCheckoutDocument = gql`
    mutation CompleteCheckout($input: CompleteCheckoutInput!) {
  completeCheckout(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type CompleteCheckoutMutationFn = Apollo.MutationFunction<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>;

/**
 * __useCompleteCheckoutMutation__
 *
 * To run a mutation, you first call `useCompleteCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCheckoutMutation, { data, loading, error }] = useCompleteCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>(CompleteCheckoutDocument, options);
      }
export type CompleteCheckoutMutationHookResult = ReturnType<typeof useCompleteCheckoutMutation>;
export type CompleteCheckoutMutationResult = Apollo.MutationResult<CompleteCheckoutMutation>;
export type CompleteCheckoutMutationOptions = Apollo.BaseMutationOptions<CompleteCheckoutMutation, CompleteCheckoutMutationVariables>;
export const CreateCheckoutPaymentMethodDocument = gql`
    mutation CreateCheckoutPaymentMethod($input: CreateCheckoutPaymentMethodInput!) {
  createCheckoutPaymentMethod(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type CreateCheckoutPaymentMethodMutationFn = Apollo.MutationFunction<CreateCheckoutPaymentMethodMutation, CreateCheckoutPaymentMethodMutationVariables>;

/**
 * __useCreateCheckoutPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutPaymentMethodMutation, { data, loading, error }] = useCreateCheckoutPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutPaymentMethodMutation, CreateCheckoutPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutPaymentMethodMutation, CreateCheckoutPaymentMethodMutationVariables>(CreateCheckoutPaymentMethodDocument, options);
      }
export type CreateCheckoutPaymentMethodMutationHookResult = ReturnType<typeof useCreateCheckoutPaymentMethodMutation>;
export type CreateCheckoutPaymentMethodMutationResult = Apollo.MutationResult<CreateCheckoutPaymentMethodMutation>;
export type CreateCheckoutPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutPaymentMethodMutation, CreateCheckoutPaymentMethodMutationVariables>;
export const UpdateCheckoutShippingAddressDocument = gql`
    mutation UpdateCheckoutShippingAddress($input: UpdateCheckoutShippingAddressInput!) {
  updateCheckoutShippingAddress(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type UpdateCheckoutShippingAddressMutationFn = Apollo.MutationFunction<UpdateCheckoutShippingAddressMutation, UpdateCheckoutShippingAddressMutationVariables>;

/**
 * __useUpdateCheckoutShippingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutShippingAddressMutation, { data, loading, error }] = useUpdateCheckoutShippingAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutShippingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutShippingAddressMutation, UpdateCheckoutShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutShippingAddressMutation, UpdateCheckoutShippingAddressMutationVariables>(UpdateCheckoutShippingAddressDocument, options);
      }
export type UpdateCheckoutShippingAddressMutationHookResult = ReturnType<typeof useUpdateCheckoutShippingAddressMutation>;
export type UpdateCheckoutShippingAddressMutationResult = Apollo.MutationResult<UpdateCheckoutShippingAddressMutation>;
export type UpdateCheckoutShippingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutShippingAddressMutation, UpdateCheckoutShippingAddressMutationVariables>;
export const UpdateCheckoutBillingAddressDocument = gql`
    mutation UpdateCheckoutBillingAddress($input: UpdateCheckoutBillingAddressInput!) {
  updateCheckoutBillingAddress(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type UpdateCheckoutBillingAddressMutationFn = Apollo.MutationFunction<UpdateCheckoutBillingAddressMutation, UpdateCheckoutBillingAddressMutationVariables>;

/**
 * __useUpdateCheckoutBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutBillingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutBillingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutBillingAddressMutation, { data, loading, error }] = useUpdateCheckoutBillingAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCheckoutBillingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutBillingAddressMutation, UpdateCheckoutBillingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutBillingAddressMutation, UpdateCheckoutBillingAddressMutationVariables>(UpdateCheckoutBillingAddressDocument, options);
      }
export type UpdateCheckoutBillingAddressMutationHookResult = ReturnType<typeof useUpdateCheckoutBillingAddressMutation>;
export type UpdateCheckoutBillingAddressMutationResult = Apollo.MutationResult<UpdateCheckoutBillingAddressMutation>;
export type UpdateCheckoutBillingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutBillingAddressMutation, UpdateCheckoutBillingAddressMutationVariables>;
export const AddCheckoutDiscountDocument = gql`
    mutation AddCheckoutDiscount($input: AddCheckoutDiscountInput!) {
  addCheckoutDiscount(input: $input) {
    ...CheckoutFragment
  }
}
    ${CheckoutFragmentFragmentDoc}`;
export type AddCheckoutDiscountMutationFn = Apollo.MutationFunction<AddCheckoutDiscountMutation, AddCheckoutDiscountMutationVariables>;

/**
 * __useAddCheckoutDiscountMutation__
 *
 * To run a mutation, you first call `useAddCheckoutDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCheckoutDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCheckoutDiscountMutation, { data, loading, error }] = useAddCheckoutDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCheckoutDiscountMutation(baseOptions?: Apollo.MutationHookOptions<AddCheckoutDiscountMutation, AddCheckoutDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCheckoutDiscountMutation, AddCheckoutDiscountMutationVariables>(AddCheckoutDiscountDocument, options);
      }
export type AddCheckoutDiscountMutationHookResult = ReturnType<typeof useAddCheckoutDiscountMutation>;
export type AddCheckoutDiscountMutationResult = Apollo.MutationResult<AddCheckoutDiscountMutation>;
export type AddCheckoutDiscountMutationOptions = Apollo.BaseMutationOptions<AddCheckoutDiscountMutation, AddCheckoutDiscountMutationVariables>;
export const OrdersDocument = gql`
    query Orders($take: Int, $skip: Int) {
  orders(take: $take, skip: $skip) {
    edges {
      node {
        id
        name
        status
        financialStatus
        grandTotal
        producer {
          name
          logo {
            src
            base64
          }
        }
        shipping {
          type
          date
        }
      }
    }
  }
}
    `;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID!) {
  order(id: $id) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const PayOrderDocument = gql`
    mutation PayOrder($input: PayOrderInput!) {
  payOrder(input: $input) {
    ...OrderFragment
  }
}
    ${OrderFragmentFragmentDoc}`;
export type PayOrderMutationFn = Apollo.MutationFunction<PayOrderMutation, PayOrderMutationVariables>;

/**
 * __usePayOrderMutation__
 *
 * To run a mutation, you first call `usePayOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payOrderMutation, { data, loading, error }] = usePayOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePayOrderMutation(baseOptions?: Apollo.MutationHookOptions<PayOrderMutation, PayOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayOrderMutation, PayOrderMutationVariables>(PayOrderDocument, options);
      }
export type PayOrderMutationHookResult = ReturnType<typeof usePayOrderMutation>;
export type PayOrderMutationResult = Apollo.MutationResult<PayOrderMutation>;
export type PayOrderMutationOptions = Apollo.BaseMutationOptions<PayOrderMutation, PayOrderMutationVariables>;
export const OrderItemsDocument = gql`
    query OrderItems($id: ID!) {
  order(id: $id) {
    id
    name
    producer {
      slug
    }
  }
  orderItems(id: $id) {
    id
    name
    variant {
      name
      unit
      type
    }
    available
    category
    subCategory
    image {
      src
      base64
      blurhash
      alt
    }
    quantity
    unitQuantity
    unitPrice
  }
}
    `;

/**
 * __useOrderItemsQuery__
 *
 * To run a query within a React component, call `useOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderItemsQuery(baseOptions: Apollo.QueryHookOptions<OrderItemsQuery, OrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderItemsQuery, OrderItemsQueryVariables>(OrderItemsDocument, options);
      }
export function useOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderItemsQuery, OrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderItemsQuery, OrderItemsQueryVariables>(OrderItemsDocument, options);
        }
export type OrderItemsQueryHookResult = ReturnType<typeof useOrderItemsQuery>;
export type OrderItemsLazyQueryHookResult = ReturnType<typeof useOrderItemsLazyQuery>;
export type OrderItemsQueryResult = Apollo.QueryResult<OrderItemsQuery, OrderItemsQueryVariables>;
export const CreatePlaidPaymentMethodDocument = gql`
    mutation CreatePlaidPaymentMethod($input: CreatePlaidPaymentMethodInput!) {
  createPlaidPaymentMethod(input: $input) {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export type CreatePlaidPaymentMethodMutationFn = Apollo.MutationFunction<CreatePlaidPaymentMethodMutation, CreatePlaidPaymentMethodMutationVariables>;

/**
 * __useCreatePlaidPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePlaidPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaidPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaidPaymentMethodMutation, { data, loading, error }] = useCreatePlaidPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaidPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaidPaymentMethodMutation, CreatePlaidPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaidPaymentMethodMutation, CreatePlaidPaymentMethodMutationVariables>(CreatePlaidPaymentMethodDocument, options);
      }
export type CreatePlaidPaymentMethodMutationHookResult = ReturnType<typeof useCreatePlaidPaymentMethodMutation>;
export type CreatePlaidPaymentMethodMutationResult = Apollo.MutationResult<CreatePlaidPaymentMethodMutation>;
export type CreatePlaidPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreatePlaidPaymentMethodMutation, CreatePlaidPaymentMethodMutationVariables>;
export const CreateCardPaymentMethodDocument = gql`
    mutation CreateCardPaymentMethod($input: CreateCardPaymentMethodInput!) {
  createCardPaymentMethod(input: $input) {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export type CreateCardPaymentMethodMutationFn = Apollo.MutationFunction<CreateCardPaymentMethodMutation, CreateCardPaymentMethodMutationVariables>;

/**
 * __useCreateCardPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateCardPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardPaymentMethodMutation, { data, loading, error }] = useCreateCardPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCardPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardPaymentMethodMutation, CreateCardPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardPaymentMethodMutation, CreateCardPaymentMethodMutationVariables>(CreateCardPaymentMethodDocument, options);
      }
export type CreateCardPaymentMethodMutationHookResult = ReturnType<typeof useCreateCardPaymentMethodMutation>;
export type CreateCardPaymentMethodMutationResult = Apollo.MutationResult<CreateCardPaymentMethodMutation>;
export type CreateCardPaymentMethodMutationOptions = Apollo.BaseMutationOptions<CreateCardPaymentMethodMutation, CreateCardPaymentMethodMutationVariables>;
export const UpdateDefaultCardPaymentDocument = gql`
    mutation UpdateDefaultCardPayment($id: ID!) {
  updateDefaultCardPayment(id: $id) {
    id
  }
}
    `;
export type UpdateDefaultCardPaymentMutationFn = Apollo.MutationFunction<UpdateDefaultCardPaymentMutation, UpdateDefaultCardPaymentMutationVariables>;

/**
 * __useUpdateDefaultCardPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultCardPaymentMutation, { data, loading, error }] = useUpdateDefaultCardPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateDefaultCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultCardPaymentMutation, UpdateDefaultCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultCardPaymentMutation, UpdateDefaultCardPaymentMutationVariables>(UpdateDefaultCardPaymentDocument, options);
      }
export type UpdateDefaultCardPaymentMutationHookResult = ReturnType<typeof useUpdateDefaultCardPaymentMutation>;
export type UpdateDefaultCardPaymentMutationResult = Apollo.MutationResult<UpdateDefaultCardPaymentMutation>;
export type UpdateDefaultCardPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultCardPaymentMutation, UpdateDefaultCardPaymentMutationVariables>;
export const DeleteCardPaymentDocument = gql`
    mutation DeleteCardPayment($id: ID!) {
  deleteCardPaymentMethod(id: $id) {
    id
  }
}
    `;
export type DeleteCardPaymentMutationFn = Apollo.MutationFunction<DeleteCardPaymentMutation, DeleteCardPaymentMutationVariables>;

/**
 * __useDeleteCardPaymentMutation__
 *
 * To run a mutation, you first call `useDeleteCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCardPaymentMutation, { data, loading, error }] = useDeleteCardPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCardPaymentMutation, DeleteCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCardPaymentMutation, DeleteCardPaymentMutationVariables>(DeleteCardPaymentDocument, options);
      }
export type DeleteCardPaymentMutationHookResult = ReturnType<typeof useDeleteCardPaymentMutation>;
export type DeleteCardPaymentMutationResult = Apollo.MutationResult<DeleteCardPaymentMutation>;
export type DeleteCardPaymentMutationOptions = Apollo.BaseMutationOptions<DeleteCardPaymentMutation, DeleteCardPaymentMutationVariables>;
export const ProducerIdsDocument = gql`
    query ProducerIds($take: Int) {
  producers(take: $take) {
    edges {
      node {
        slug
      }
    }
  }
}
    `;

/**
 * __useProducerIdsQuery__
 *
 * To run a query within a React component, call `useProducerIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerIdsQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function useProducerIdsQuery(baseOptions?: Apollo.QueryHookOptions<ProducerIdsQuery, ProducerIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerIdsQuery, ProducerIdsQueryVariables>(ProducerIdsDocument, options);
      }
export function useProducerIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerIdsQuery, ProducerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerIdsQuery, ProducerIdsQueryVariables>(ProducerIdsDocument, options);
        }
export type ProducerIdsQueryHookResult = ReturnType<typeof useProducerIdsQuery>;
export type ProducerIdsLazyQueryHookResult = ReturnType<typeof useProducerIdsLazyQuery>;
export type ProducerIdsQueryResult = Apollo.QueryResult<ProducerIdsQuery, ProducerIdsQueryVariables>;
export const ProducerDocument = gql`
    query Producer($slug: String, $take: Int, $level: PriceLevel) {
  producer(slug: $slug) {
    id
    name
    slug
    description {
      retail
      wholesale
    }
    city
    province
    image {
      src
      base64
    }
    logo {
      src
      base64
    }
    products(take: $take, level: $level) {
      edges {
        node {
          ...ProductNode
        }
      }
    }
  }
}
    ${ProductNodeFragmentDoc}`;

/**
 * __useProducerQuery__
 *
 * To run a query within a React component, call `useProducerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      take: // value for 'take'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useProducerQuery(baseOptions?: Apollo.QueryHookOptions<ProducerQuery, ProducerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducerQuery, ProducerQueryVariables>(ProducerDocument, options);
      }
export function useProducerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducerQuery, ProducerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducerQuery, ProducerQueryVariables>(ProducerDocument, options);
        }
export type ProducerQueryHookResult = ReturnType<typeof useProducerQuery>;
export type ProducerLazyQueryHookResult = ReturnType<typeof useProducerLazyQuery>;
export type ProducerQueryResult = Apollo.QueryResult<ProducerQuery, ProducerQueryVariables>;
export const ProducersPopularDocument = gql`
    query ProducersPopular {
  mountain: producer(slug: "mountain") {
    ...ProducerPopularFragment
  }
  norwich: producer(slug: "norwich") {
    ...ProducerPopularFragment
  }
  tonjes: producer(slug: "tonjes") {
    ...ProducerPopularFragment
  }
}
    ${ProducerPopularFragmentFragmentDoc}`;

/**
 * __useProducersPopularQuery__
 *
 * To run a query within a React component, call `useProducersPopularQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducersPopularQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducersPopularQuery({
 *   variables: {
 *   },
 * });
 */
export function useProducersPopularQuery(baseOptions?: Apollo.QueryHookOptions<ProducersPopularQuery, ProducersPopularQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducersPopularQuery, ProducersPopularQueryVariables>(ProducersPopularDocument, options);
      }
export function useProducersPopularLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducersPopularQuery, ProducersPopularQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducersPopularQuery, ProducersPopularQueryVariables>(ProducersPopularDocument, options);
        }
export type ProducersPopularQueryHookResult = ReturnType<typeof useProducersPopularQuery>;
export type ProducersPopularLazyQueryHookResult = ReturnType<typeof useProducersPopularLazyQuery>;
export type ProducersPopularQueryResult = Apollo.QueryResult<ProducersPopularQuery, ProducersPopularQueryVariables>;
export const ProducersByLocationDocument = gql`
    query ProducersByLocation($lat: Latitude, $lng: Longitude) {
  producersByLocation(lat: $lat, lng: $lng) {
    edges {
      node {
        id
        name
        image {
          src
          base64
        }
        city
        province
        slug
      }
    }
  }
}
    `;

/**
 * __useProducersByLocationQuery__
 *
 * To run a query within a React component, call `useProducersByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducersByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducersByLocationQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *   },
 * });
 */
export function useProducersByLocationQuery(baseOptions?: Apollo.QueryHookOptions<ProducersByLocationQuery, ProducersByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducersByLocationQuery, ProducersByLocationQueryVariables>(ProducersByLocationDocument, options);
      }
export function useProducersByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducersByLocationQuery, ProducersByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducersByLocationQuery, ProducersByLocationQueryVariables>(ProducersByLocationDocument, options);
        }
export type ProducersByLocationQueryHookResult = ReturnType<typeof useProducersByLocationQuery>;
export type ProducersByLocationLazyQueryHookResult = ReturnType<typeof useProducersByLocationLazyQuery>;
export type ProducersByLocationQueryResult = Apollo.QueryResult<ProducersByLocationQuery, ProducersByLocationQueryVariables>;
export const ProducersFeaturedDocument = gql`
    query ProducersFeatured {
  producersFeatured {
    edges {
      node {
        id
        name
        image {
          src
          base64
        }
        city
        province
        slug
      }
    }
  }
}
    `;

/**
 * __useProducersFeaturedQuery__
 *
 * To run a query within a React component, call `useProducersFeaturedQuery` and pass it any options that fit your needs.
 * When your component renders, `useProducersFeaturedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProducersFeaturedQuery({
 *   variables: {
 *   },
 * });
 */
export function useProducersFeaturedQuery(baseOptions?: Apollo.QueryHookOptions<ProducersFeaturedQuery, ProducersFeaturedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProducersFeaturedQuery, ProducersFeaturedQueryVariables>(ProducersFeaturedDocument, options);
      }
export function useProducersFeaturedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProducersFeaturedQuery, ProducersFeaturedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProducersFeaturedQuery, ProducersFeaturedQueryVariables>(ProducersFeaturedDocument, options);
        }
export type ProducersFeaturedQueryHookResult = ReturnType<typeof useProducersFeaturedQuery>;
export type ProducersFeaturedLazyQueryHookResult = ReturnType<typeof useProducersFeaturedLazyQuery>;
export type ProducersFeaturedQueryResult = Apollo.QueryResult<ProducersFeaturedQuery, ProducersFeaturedQueryVariables>;
export const PreRenderProductsDocument = gql`
    query PreRenderProducts($take: Int, $level: PriceLevel) {
  products(take: $take, level: $level) {
    edges {
      node {
        id
        producer {
          slug
        }
      }
    }
  }
}
    `;

/**
 * __usePreRenderProductsQuery__
 *
 * To run a query within a React component, call `usePreRenderProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreRenderProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreRenderProductsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      level: // value for 'level'
 *   },
 * });
 */
export function usePreRenderProductsQuery(baseOptions?: Apollo.QueryHookOptions<PreRenderProductsQuery, PreRenderProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreRenderProductsQuery, PreRenderProductsQueryVariables>(PreRenderProductsDocument, options);
      }
export function usePreRenderProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreRenderProductsQuery, PreRenderProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreRenderProductsQuery, PreRenderProductsQueryVariables>(PreRenderProductsDocument, options);
        }
export type PreRenderProductsQueryHookResult = ReturnType<typeof usePreRenderProductsQuery>;
export type PreRenderProductsLazyQueryHookResult = ReturnType<typeof usePreRenderProductsLazyQuery>;
export type PreRenderProductsQueryResult = Apollo.QueryResult<PreRenderProductsQuery, PreRenderProductsQueryVariables>;
export const ProductDocument = gql`
    query Product($id: ID!, $level: PriceLevel) {
  product(id: $id, level: $level) {
    ...ProductNode
    description
    producer {
      name
      city
      description {
        retail
        wholesale
      }
      province
      slug
      image {
        src
        base64
      }
      logo {
        src
        base64
      }
    }
  }
}
    ${ProductNodeFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ShippingDocument = gql`
    query Shipping($producerId: ID!) {
  shipping(producerId: $producerId) {
    type
    edges {
      node {
        next
        until
        location {
          id
          name
          address1
          city
          province
          zip
          pickupStart
          pickupEnd
          image {
            src
          }
        }
      }
    }
  }
}
    `;

/**
 * __useShippingQuery__
 *
 * To run a query within a React component, call `useShippingQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingQuery({
 *   variables: {
 *      producerId: // value for 'producerId'
 *   },
 * });
 */
export function useShippingQuery(baseOptions: Apollo.QueryHookOptions<ShippingQuery, ShippingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingQuery, ShippingQueryVariables>(ShippingDocument, options);
      }
export function useShippingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingQuery, ShippingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingQuery, ShippingQueryVariables>(ShippingDocument, options);
        }
export type ShippingQueryHookResult = ReturnType<typeof useShippingQuery>;
export type ShippingLazyQueryHookResult = ReturnType<typeof useShippingLazyQuery>;
export type ShippingQueryResult = Apollo.QueryResult<ShippingQuery, ShippingQueryVariables>;
export const AccountUserDocument = gql`
    query AccountUser {
  user {
    ...UserFragment
    shippingAddresses {
      ...UserAddressFragment
    }
    billingAddresses {
      ...UserAddressFragment
    }
  }
}
    ${UserFragmentFragmentDoc}
${UserAddressFragmentFragmentDoc}`;

/**
 * __useAccountUserQuery__
 *
 * To run a query within a React component, call `useAccountUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountUserQuery(baseOptions?: Apollo.QueryHookOptions<AccountUserQuery, AccountUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUserQuery, AccountUserQueryVariables>(AccountUserDocument, options);
      }
export function useAccountUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUserQuery, AccountUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUserQuery, AccountUserQueryVariables>(AccountUserDocument, options);
        }
export type AccountUserQueryHookResult = ReturnType<typeof useAccountUserQuery>;
export type AccountUserLazyQueryHookResult = ReturnType<typeof useAccountUserLazyQuery>;
export type AccountUserQueryResult = Apollo.QueryResult<AccountUserQuery, AccountUserQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  user {
    id
    firstName
    email
    team {
      name
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UserTeamMembersDocument = gql`
    query UserTeamMembers {
  user {
    ...UserTeamMembersFragment
  }
}
    ${UserTeamMembersFragmentFragmentDoc}`;

/**
 * __useUserTeamMembersQuery__
 *
 * To run a query within a React component, call `useUserTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<UserTeamMembersQuery, UserTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTeamMembersQuery, UserTeamMembersQueryVariables>(UserTeamMembersDocument, options);
      }
export function useUserTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTeamMembersQuery, UserTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTeamMembersQuery, UserTeamMembersQueryVariables>(UserTeamMembersDocument, options);
        }
export type UserTeamMembersQueryHookResult = ReturnType<typeof useUserTeamMembersQuery>;
export type UserTeamMembersLazyQueryHookResult = ReturnType<typeof useUserTeamMembersLazyQuery>;
export type UserTeamMembersQueryResult = Apollo.QueryResult<UserTeamMembersQuery, UserTeamMembersQueryVariables>;
export const UserPaymentMethodsDocument = gql`
    query UserPaymentMethods {
  user {
    id
    paymentMethods {
      ...PaymentMethodFragment
    }
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;

/**
 * __useUserPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useUserPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>(UserPaymentMethodsDocument, options);
      }
export function useUserPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>(UserPaymentMethodsDocument, options);
        }
export type UserPaymentMethodsQueryHookResult = ReturnType<typeof useUserPaymentMethodsQuery>;
export type UserPaymentMethodsLazyQueryHookResult = ReturnType<typeof useUserPaymentMethodsLazyQuery>;
export type UserPaymentMethodsQueryResult = Apollo.QueryResult<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>;
export const UserAddressesDocument = gql`
    query UserAddresses {
  user {
    id
    shippingAddresses {
      ...UserAddressFragment
    }
    billingAddresses {
      ...UserAddressFragment
    }
  }
}
    ${UserAddressFragmentFragmentDoc}`;

/**
 * __useUserAddressesQuery__
 *
 * To run a query within a React component, call `useUserAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAddressesQuery(baseOptions?: Apollo.QueryHookOptions<UserAddressesQuery, UserAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAddressesQuery, UserAddressesQueryVariables>(UserAddressesDocument, options);
      }
export function useUserAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAddressesQuery, UserAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAddressesQuery, UserAddressesQueryVariables>(UserAddressesDocument, options);
        }
export type UserAddressesQueryHookResult = ReturnType<typeof useUserAddressesQuery>;
export type UserAddressesLazyQueryHookResult = ReturnType<typeof useUserAddressesLazyQuery>;
export type UserAddressesQueryResult = Apollo.QueryResult<UserAddressesQuery, UserAddressesQueryVariables>;
export const CreateUserAddressDocument = gql`
    mutation CreateUserAddress($input: CreateUserAddressInput!) {
  createUserAddress(input: $input) {
    id
    shippingAddresses {
      ...UserAddressFragment
    }
    billingAddresses {
      ...UserAddressFragment
    }
  }
}
    ${UserAddressFragmentFragmentDoc}`;
export type CreateUserAddressMutationFn = Apollo.MutationFunction<CreateUserAddressMutation, CreateUserAddressMutationVariables>;

/**
 * __useCreateUserAddressMutation__
 *
 * To run a mutation, you first call `useCreateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAddressMutation, { data, loading, error }] = useCreateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAddressMutation, CreateUserAddressMutationVariables>(CreateUserAddressDocument, options);
      }
export type CreateUserAddressMutationHookResult = ReturnType<typeof useCreateUserAddressMutation>;
export type CreateUserAddressMutationResult = Apollo.MutationResult<CreateUserAddressMutation>;
export type CreateUserAddressMutationOptions = Apollo.BaseMutationOptions<CreateUserAddressMutation, CreateUserAddressMutationVariables>;
export const DeleteUserAddressDocument = gql`
    mutation DeleteUserAddress($id: ID!) {
  deleteUserAddress(id: $id) {
    id
    shippingAddresses {
      ...UserAddressFragment
    }
    billingAddresses {
      ...UserAddressFragment
    }
  }
}
    ${UserAddressFragmentFragmentDoc}`;
export type DeleteUserAddressMutationFn = Apollo.MutationFunction<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;

/**
 * __useDeleteUserAddressMutation__
 *
 * To run a mutation, you first call `useDeleteUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAddressMutation, { data, loading, error }] = useDeleteUserAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>(DeleteUserAddressDocument, options);
      }
export type DeleteUserAddressMutationHookResult = ReturnType<typeof useDeleteUserAddressMutation>;
export type DeleteUserAddressMutationResult = Apollo.MutationResult<DeleteUserAddressMutation>;
export type DeleteUserAddressMutationOptions = Apollo.BaseMutationOptions<DeleteUserAddressMutation, DeleteUserAddressMutationVariables>;
export const InitiateResetPasswordDocument = gql`
    mutation InitiateResetPassword($input: InitiateResetPasswordInput!) {
  initiateResetPassword(input: $input) {
    email
  }
}
    `;
export type InitiateResetPasswordMutationFn = Apollo.MutationFunction<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>;

/**
 * __useInitiateResetPasswordMutation__
 *
 * To run a mutation, you first call `useInitiateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateResetPasswordMutation, { data, loading, error }] = useInitiateResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>(InitiateResetPasswordDocument, options);
      }
export type InitiateResetPasswordMutationHookResult = ReturnType<typeof useInitiateResetPasswordMutation>;
export type InitiateResetPasswordMutationResult = Apollo.MutationResult<InitiateResetPasswordMutation>;
export type InitiateResetPasswordMutationOptions = Apollo.BaseMutationOptions<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>;
export const VerifyResetPasswordTokenDocument = gql`
    mutation VerifyResetPasswordToken($input: VerifyResetPasswordTokenInput!) {
  verifyResetPasswordToken(input: $input) {
    user {
      id
    }
    changePasswordToken
    authenticationToken
  }
}
    `;
export type VerifyResetPasswordTokenMutationFn = Apollo.MutationFunction<VerifyResetPasswordTokenMutation, VerifyResetPasswordTokenMutationVariables>;

/**
 * __useVerifyResetPasswordTokenMutation__
 *
 * To run a mutation, you first call `useVerifyResetPasswordTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyResetPasswordTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyResetPasswordTokenMutation, { data, loading, error }] = useVerifyResetPasswordTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyResetPasswordTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyResetPasswordTokenMutation, VerifyResetPasswordTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyResetPasswordTokenMutation, VerifyResetPasswordTokenMutationVariables>(VerifyResetPasswordTokenDocument, options);
      }
export type VerifyResetPasswordTokenMutationHookResult = ReturnType<typeof useVerifyResetPasswordTokenMutation>;
export type VerifyResetPasswordTokenMutationResult = Apollo.MutationResult<VerifyResetPasswordTokenMutation>;
export type VerifyResetPasswordTokenMutationOptions = Apollo.BaseMutationOptions<VerifyResetPasswordTokenMutation, VerifyResetPasswordTokenMutationVariables>;
export const ChangeUserPasswordDocument = gql`
    mutation ChangeUserPassword($input: ChangeUserPasswordInput!) {
  changeUserPassword(input: $input) {
    email
  }
}
    `;
export type ChangeUserPasswordMutationFn = Apollo.MutationFunction<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;

/**
 * __useChangeUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserPasswordMutation, { data, loading, error }] = useChangeUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>(ChangeUserPasswordDocument, options);
      }
export type ChangeUserPasswordMutationHookResult = ReturnType<typeof useChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationResult = Apollo.MutationResult<ChangeUserPasswordMutation>;
export type ChangeUserPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeUserPasswordMutation, ChangeUserPasswordMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    email
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserAddressDocument = gql`
    mutation UpdateUserAddress($input: UpdateUserAddressInput!) {
  updateUserAddress(input: $input) {
    id
    shippingAddresses {
      ...UserAddressFragment
    }
    billingAddresses {
      ...UserAddressFragment
    }
  }
}
    ${UserAddressFragmentFragmentDoc}`;
export type UpdateUserAddressMutationFn = Apollo.MutationFunction<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;

/**
 * __useUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAddressMutation, { data, loading, error }] = useUpdateUserAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>(UpdateUserAddressDocument, options);
      }
export type UpdateUserAddressMutationHookResult = ReturnType<typeof useUpdateUserAddressMutation>;
export type UpdateUserAddressMutationResult = Apollo.MutationResult<UpdateUserAddressMutation>;
export type UpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<UpdateUserAddressMutation, UpdateUserAddressMutationVariables>;
export const CreateTeamMemberDocument = gql`
    mutation CreateTeamMember($input: CreateTeamMemberInput!) {
  createTeamMember(input: $input) {
    ...UserTeamMembersFragment
  }
}
    ${UserTeamMembersFragmentFragmentDoc}`;
export type CreateTeamMemberMutationFn = Apollo.MutationFunction<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;

/**
 * __useCreateTeamMemberMutation__
 *
 * To run a mutation, you first call `useCreateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMemberMutation, { data, loading, error }] = useCreateTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>(CreateTeamMemberDocument, options);
      }
export type CreateTeamMemberMutationHookResult = ReturnType<typeof useCreateTeamMemberMutation>;
export type CreateTeamMemberMutationResult = Apollo.MutationResult<CreateTeamMemberMutation>;
export type CreateTeamMemberMutationOptions = Apollo.BaseMutationOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;
export const UpdateTeamMemberDocument = gql`
    mutation UpdateTeamMember($input: UpdateTeamMemberInput!) {
  updateTeamMember(input: $input) {
    ...UserTeamMembersFragment
  }
}
    ${UserTeamMembersFragmentFragmentDoc}`;
export type UpdateTeamMemberMutationFn = Apollo.MutationFunction<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;

/**
 * __useUpdateTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMemberMutation, { data, loading, error }] = useUpdateTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>(UpdateTeamMemberDocument, options);
      }
export type UpdateTeamMemberMutationHookResult = ReturnType<typeof useUpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationResult = Apollo.MutationResult<UpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;
export const DeleteTeamMemberDocument = gql`
    mutation DeleteTeamMember($id: ID!) {
  deleteTeamMember(id: $id) {
    ...UserTeamMembersFragment
  }
}
    ${UserTeamMembersFragmentFragmentDoc}`;
export type DeleteTeamMemberMutationFn = Apollo.MutationFunction<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;

/**
 * __useDeleteTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberMutation, { data, loading, error }] = useDeleteTeamMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>(DeleteTeamMemberDocument, options);
      }
export type DeleteTeamMemberMutationHookResult = ReturnType<typeof useDeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationResult = Apollo.MutationResult<DeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;